import { AccountCircle } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React, { ReactNode } from 'react';
import { StyleObj } from '../../../@types';
import { useSkin } from '../../../contexts/SkinContext';
import { SKIN, Skin } from '../../../types/enums';
import UnreadMessagesBadge from '../../atoms/UnreadMessagesBadge';
import AccountIcon from '../../skins/gola/icons/AccountIcon';

const SKIN_ACCOUNT_ICON_MAP: Partial<Record<Skin, ReactNode>> = {
  [SKIN.GOLA]: <AccountIcon color='info' />,
};

const DEFAULT_ICON = <AccountCircle color='info' />;

const styles: StyleObj = {
  accountButton: {
    p: 0,
    m: 0,
    cursor: 'pointer',
    color: (theme) => theme.palette.primary.light,
    '& svg': {
      fontSize: {
        xs: 24,
        md: 32,
      },
    },
  },
};

type AccountMenuButtonProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  showUnreadBadge?: boolean;
};

export const AccountMenuButton = ({ onClick, showUnreadBadge = true }: AccountMenuButtonProps) => {
  const { skin } = useSkin();
  const icon = SKIN_ACCOUNT_ICON_MAP[skin] ?? DEFAULT_ICON;

  return (
    <IconButton aria-haspopup='true' edge='end' aria-label='menu' onClick={onClick} sx={styles.accountButton}>
      {showUnreadBadge ? <UnreadMessagesBadge>{icon}</UnreadMessagesBadge> : icon}
    </IconButton>
  );
};
